<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                用户详情
                <!-- 顶部按钮 -->
                <!-- <div class="con_topL pointer  con_topL_active" >用户详情</div> -->
                <!-- <router-link to='/layout/user/editData2' ><div class="con_topL pointer " >编辑资料</div></router-link> -->
                <!-- <router-link to='/layout/home/loginLog2' ><div class="con_topL pointer "  >登录日志</div></router-link> -->

                <div class="back_btn" @click="back()">
                    <Icon type="ios-arrow-back" />返回
                </div>
            </div>
            
            <!-- table手写 -->
            
            <table class='table_content1' border='0' width='100%' align='center'>
                <tr>
                    <td width='250' rowspan='3'>
                        <div  class='tableL' >
                            <p class="p1">
                                <img :src="listTop.image"  v-if='listTop.image' alt="">
                                <img  src="../../../../public/images/head_01.png"  v-if='!listTop.image' alt="">
                            </p>
                            <p class="p2">
                                {{listTop.surname}}{{listTop.name}}
                            </p>
                            <p class="p2">
                                {{listTop.mobile}}
                            </p>
                            <p class="p3">
                                <span>{{listTop.vipName}}</span>  
                            </p>
                            <p class="p4  pointer" @click='clear_head '>
                                清除头像
                            </p>
                        </div>
                    </td>
                    <td class='title'>用户ID</td>
                    <td class='t_con' >{{listTop.number}}</td>
                    <td class='title'>性别</td>
                    <td class='t_con' v-if='listTop.sex == 0'>
                        未知
                    </td>
                    <td class='t_con' v-if='listTop.sex == 1'>
                        男
                    </td>
                    <td class='t_con' v-if='listTop.sex == 2'>
                        女
                    </td>
                    <td class='title'>邀请码</td>
                    <td class='t_con'>{{listTop.invitationCode}}</td>

                    
                    
                </tr>
                <tr>
                    <td class='title'>注册时间</td>
                    <td class='t_con'>{{listTop.createTime}}</td>
                    <td class='title'>最后登录时间</td>
                    <td class='t_con'>{{listTop.lastLoginTime}}</td>

                    <td class='title'>添加好友</td>
                    <td class='t_con'>{{listTop.friendCount}}</td>
                   
                    
                </tr>
                <tr>
                    <td class='title'>持有股份</td>
                    <td class='t_con'>{{listTop.shares}}</td>
                    <td class='title'>登录次数</td>
                    <td class='t_con'>{{listTop.loginCount}}</td>
                   
                    <td class='title'>登录城市及IP</td>
                    <td class='t_con'>{{listTop.lastLoginInfo}}({{listTop.lastLoginIp}})</td>
                  
                </tr>
                
            </table>
               
              
            <!-- 邀请好友 -->
            <!-- table组件  list1 -->
            <div class="my_table  my_title_table">
               <div>
                   <div class="title2">
                       <Icon type="md-bookmark" />邀请好友 ( {{listTop.invitationCount}} )
                   </div>
                   <Table border :columns="columns1" :data="data1" ref='table'>
                       
                       
                        <!-- 头像 -->
                        <template slot-scope="{ row }" slot="image">
                            <div class="demo-avatar">
                                <Avatar v-if="row.image == null" icon="ios-person" size="large" />
                                <Avatar v-else  :src="row.image" size="large"/> 
                            </div>                        
                        </template>
                        
                        <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                            <Poptip trigger="hover" :title="row.surname" content="查看">
                                <Button class='padlr5'  type="info" size="small" icon="md-search" style="" @click="show1(index)"></Button>
                            </Poptip>
                        </template>
                        
                    </Table>
                    <Footer>
                        <Page  :current.sync="page1" :total="toatalPage1" :page-size='pageSize1'    @on-change='changepage1'  show-total  show-elevator />
                    </Footer>

               </div>
            </div>

            <!-- 业绩记录  list2 -->
            <div class="my_table  my_title_table">
               <div>
                   <div class="title2">
                       <Icon type="md-bookmark" />业绩记录 ( {{listTop.totalPerformance}} )
                   </div>
                   <Table     border  :columns="columns2" :data="data2" ref='table2'>
                       <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                            <Poptip trigger="hover" :title="row.order_number" content="查看">
                                <Button class='padlr5'  type="info" icon="md-search" size="small" style="" @click="show2(index)"></Button>  
                            </Poptip>                 
                        </template>
                   </Table>
                    <Footer>
                        <Page  :current.sync="page2" :total="toatalPage2" :page-size='pageSize2'    @on-change='changepage2'  show-total  show-elevator />
                    </Footer>

               </div>
            </div>
            <!-- 孝心值查询  list3-->
            <div class="my_table  my_title_table">
                <div class="title2">
                    <Icon type="md-bookmark" />孝心值查询
                </div>
               <Header class="my_title txt_l">
                    <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                        筛选查询
                    </span>
                    <div class="ct_rgt">
                        
                        <div class="sta_btn " type="primary"   @click="exportData3">导出数据</div>
                        
                    </div>
                </Header>
                
                <div class="my_search">
                
                    
                        <Row class="search_row">  
                        <div  class="search_name">
                            孝心值来源:  
                        </div>
                            
                        <Col span="4">
                            <Select  class='selectL'  v-model="type3"  @on-change='typeFun3'     clearable style="">
                                <Option v-for="item in types3"     :value="item.value" :key="item.value"  >{{ item.label }}</Option>
                            </Select>
                        </Col>
                        
                        <div  class="search_name">
                            操作时间:
                        </div>
                        
                        <Col span="4">

                            <DatePicker ref='isFocuseC'   @on-change='timeFun3' v-model="time3" type="date"   placeholder="请选择时间"  clearable ></DatePicker>
                        </Col>
                    </Row>       
                </div>
                <Table border :columns="columns3" :data="data3" ref='table3'></Table>
                <Footer>
                    <Page  :current.sync="page3" :total="toatalPage3" :page-size='pageSize3'    @on-change='changepage3'  show-total  show-elevator />
                </Footer>
                
            </div>
            <!-- 佣金列表  list4-->
            <div class="my_table  my_title_table" style='margin-bottom:20px;'>
                <div class="title2">
                    <Icon type="md-bookmark" />佣金列表
                </div>
               <Header class="my_title txt_l">
                    <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                        筛选查询
                    </span>
                    <div class="ct_rgt">
                        
                        <div class="sta_btn " type="primary"   @click="exportData4">导出数据</div>
                        
                    </div>
                </Header>
                
                <div class="my_search">
                
                    
                        <Row class="search_row">  
                        <div  class="search_name">
                            佣金来源:  
                        </div>
                            
                        <Col span="4">
                            <Select  class='selectL'  v-model="type4"  @on-change='typeFun4'     clearable style="">
                                <Option v-for="item in types4"     :value="item.value" :key="item.value"  >{{ item.label }}</Option>
                            </Select>
                        </Col>
                        
                        <div  class="search_name">
                            操作时间:
                        </div>
                        
                        <Col span="4">

                            <DatePicker ref='isFocuseC'   @on-change='timeFun4' v-model="time4" type="date"   placeholder="请选择时间"  clearable ></DatePicker>
                        </Col>
                    </Row>       
                </div>
                <Table border :columns="columns4" :data="data4" ref='table4'></Table>
                <Footer>
                    <Page  :current.sync="page4" :total="toatalPage4" :page-size='pageSize4'    @on-change='changepage4'  show-total  show-elevator />
                </Footer>
                
            </div>
            

       </div>
       

       
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';

    export default {
        name:'list',
        data () {
            return {
                token:'',

                checkGuid2:'',
              
                date:'',

                // table
                total:null,
              
                toatalPage:0,
                page:1,
                pageCurrent:1,
                pageSize:20,

            //    列表
                listTop:Object,

                 columns0:[
                    {
                        title: '消费金额',
                        key: 'expenditureAmount',
                    
                        align:'center'
                    },
                    {
                        title: '邀请好友',
                        key: 'invitationCount',
                        align:'center'
                    },
                    {
                        title: '可用孝心值',
                        key: 'integral',
                        align:'center'
                    },
                    {
                        title: '佣金金额',
                        key: 'commission',
                        align:'center'
                    },
                    // {
                    //     title: '提现金额',
                    //     key: 'null',
                    //     align:'center'
                    // },
                    {
                        title: '添加好友',
                        key: 'friendCount',
                        align:'center'
                    },
                    {
                        title: '持有股份',
                        key: 'shares',
                        align:'center'
                    },
                    {
                        title: '业绩总额',
                        key: 'totalPerformance',
                        align:'center'
                    },
                    {
                        title: '登录次数',
                        key: 'loginCount',
                        align:'center'
                    }
                   
                   
                ],
                data0:[],

                // list2
                columns1:[
                    
                ],
                data1:[],
                page1:1,
                toatalPage1:1,
                pageSize1:1,
                total1:[],

                // list2
                columns2:[],
                data2:[],
                page2:1,
                toatalPage2:1,
                pageSize2: 1,
                total2:[],


                //list3
                columns3:[],
                data3:[],
                page3:1,
                toatalPage3:1,
                pageSize3:1,
                total3:[],

                 // 搜索
                type3:'',
                types3:[
                    {value:'0',label:'注册'},
                    {value:'1',label:'签到 '},
                    {value:'2',label:'邀请 '},
                    {value:'3',label:'红包'},
                    {value:'4',label:'纪念堂相关'},
                    {value:'5',label:'赠送孝心值'},
                    {value:'6',label:'管理员'}
                ],

                time3:'',

                //list4
                columns4:[],
                data4:[],
                page4:1,
                toatalPage4:1,
                pageSize4:1,
                total4:[],
              
                 // 搜索
                type4:'',
                types4:[
                    {value:'1',label:'孝心值充值'},
                    {value:'2',label:'会员充值'},
                    {value:'3',label:'购买商品'}
                ],
                time4:''
            }
        },
       
     
        computed: {
           
            
        },
        methods: {
            load(){
                var that = this;
                 // vuex
                that.token = that.$store.state.token;
                that.image = that.$store.state.image;
           
                that.checkGuid2 = that.$store.state.checkGuid2;

                // data0

                var url;
                url = 'admin/service/admin/user?';
               
                that.$ajax({
                
                    method:'get',
                    url: url+'guid='+that.checkGuid2,
                    data: {},
                   
                }).then(res => {
                    that.listTop = res.data.data;
                    
                    var list = [];
                    var len = list.length;
                    list.push(that.listTop);
                    
                    // 订单信息
                    //  消费金额  
                    list[0].expenditureAmount = '￥'+ (list[0].expenditureAmount/100).toFixed(2);
                    //佣金金额
                    list[0].commission = '￥'+ (list[0].commission/100).toFixed(2);
                    
                    //业绩总额
                    list[0].totalPerformance = '￥'+ (list[0].totalPerformance/100).toFixed(2);
                  
                    that.data0 = list;
                    
                }).catch(err=>{
                    console.log(err)
                })

                // data1列表  邀请好友
                that.$ajax({
                
                    method:'get',
                    url: 'admin/service/admin/user/invitation/users?guid='+that.checkGuid2+'&page='+that.page1,
                    data: {},
                    
                }).then(res => {
                        
                    var total = res.data.data;
                    var list =res.data.data.list;
                    
                    
                    that.total1 = total;
                    var len = list.length;
                    that.columns1=[
                        {title:'用户ID',key:'number',align:'center'},
                        {title:'用户账号',key:'mobile',align:'center'},
                        {title:'用户昵称',key:'surname',align:'center'},
                        {title:'头像',slot:'image',align:'center'},
                        {title:'会员等级',key:'vipName',align:'center'},
                        {title:'消费金额',key:'expenditureAmount',align:'center'},
                        {title:'邀请好友',key:'invitationCount',align:'center',width:85},
                        {title:'创建时间',key:'createTime',align:'center',width:110},
                        {title:'可用孝心值',key:'integral',align:'center',width:85},
                        {title:'最后登录时间',key:'lastLoginTime',align:'center',width:110},
                        {title:'操作',slot:'btn',align:'center',fixed: 'right'}
                    ]
                     
                    for(var i=0;i<len;i++){
                         //用户昵称
                        list[i].surname = list[i].surname + list[i].name;
                        //消费金额   改json
                        list[i].expenditureAmount = '￥'+ (list[i].expenditureAmount/100).toFixed(2);
                    }
    
                    
                    that.data1 = list;

                    that.toatalPage1 = total.total;
                    that.pageSize1 = total.pageSize;
                    
                
                }).catch(err=>{
                    console.log(err)
                })


                // data2列表  list2
                //   数据列表
                that.$ajax({

                    method:'get',
                    url: 'admin/service/admin/user/invitation/order?guid='+that.checkGuid2+'&page='+that.page2,
                    data: {},
                   
                }).then(res => {
                        
                    var total = res.data.data;
                    var list =res.data.data.list;
                    
                    that.total2 = total;
                    var len = list.length;
                    
                        
                    that.columns2 = [
                       


                        {title:'订单编号',key:'order_number',align:'center'},
                        {title:'提交时间',key:'create_time',align:'center',minWidth: 125,maxWidth:200},
                        {title:'用户账号',key:'mobile',align:'center'},
                        {title:'消费金额',key:'money',align:'center',minWidth:150},
                        {title:'获得提成',key:'commission',align:'center'},
                        {title:'订单来源',key:'type',align:'center'},
                        {title:'订单状态',key:'state',align:'center'},
                        // {title:'操作',slot:'btn',align:'center'}
                       
                        
                    ];
                    
                    for(var i=0;i<len;i++){
                      
                        //消费金额   改json
                        list[i].money = '￥'+ (list[i].money/100).toFixed(2);
                        //获得提成  改json
                        list[i].commission = '￥'+ (list[i].commission/100).toFixed(2);
    
                        //   订单来源
                        if(list[i].type == 1){
                            list[i].type = '孝心值充值';
                        }else if(list[i].type == 2){
                            list[i].type = '会员充值';
                        }else{
                            list[i].type = '购买商品';
                        }
                        //   订单状态
                        // 0 预支付订单 1 成功 2 失败 3退卡 4 用户取消交易
                        if(list[i].state == 0){
                            list[i].state = '预支付订单';
                        }else if(list[i].state == 1){
                            list[i].state = '成功';
                        }else if(list[i].state == 2){
                            list[i].state = '失败';
                        }else if(list[i].state == 3){
                            list[i].state = '退卡';
                        }else{
                            list[i].state = '用户取消交易';
                        }
                    }
                    that.data2= list;

                    that.toatalPage2 = total.total;
                    that.pageSize2 = total.pageSize;
                    
                
                }).catch(err=>{
                    console.log(err)
                })

    
              
           },
         
           changepage1(index){
               var that = this;
               var url = 'admin/service/admin/users/search?page='+that.page1;
               that.load();
           },
           changepage2(index){
               var that = this;
               var url = 'admin/service/admin/users/search?page='+that.page2;
               that.load();
           },

            clear_head(){
               var that = this;
               var img;
               if(that.listTop.sex == 1){
                   img='/images/default_head_man.png' ;
                   
               }else if(that.listTop.sex == 2){
                   img='/images/default_head_woman.png';
                   
               }else{   // sex == 0
                  img='/images/default_head_woman.png';
               }
                that.$ajax({
                    
                    method:'put',
                    url: 'account/service/user',
                    data: {
                        "guid":that.checkGuid2,
                       
                        "image":img


                    },
                   
                }).then(res => {
                    // 刷新
                    that.load();
               
                }).catch(err=>{
                    console.log(err)
                })
          },
          // 点击表格跳转按钮
            show1(data){
                var that = this;
                var checkGuid2 = that.data1[data].guid;
                that.$store.commit('change_checkGuid2',checkGuid2);
                that.page = 1;
                that.load();
                that.load3(0);
                that.load4(0);
                
            },
          // 点击表格跳转按钮
            show2(data){
                var that = this;
                var checkGuid2 = that.data1[data].guid;
                that.$store.commit('change_checkGuid2',checkGuid2);
                that.$router.push({path:'/layout/user/list2'});
               
                
            },


            // list3
            load3(btn){

                var that = this;
                 // vuex
                that.token = that.$store.state.token;
                 
                var url;
                var mUrl = 'admin/service/admin/user/search/gold_coin_log?guid='+that.checkGuid2;
                //  0是关闭和初始,1是搜索框，2是分页
                if(btn == 0){
                    url = mUrl+'&page=1';  //初始化
                }else if(btn == 1){
                    if(that.type3){
                        url = mUrl+'&page=1&type='+that.type3;  //提交type
                    }else if(that.time3){
                        url = mUrl+'&page=1&time='+that.time3;   //提交time
                    }else{
                        url = mUrl + '&page=1';
                    }
                }else if(btn == 2){
                    if(that.type3){
                        url = mUrl+'&page='+that.page+'&type='+that.type3;
                    }else if(that.time3){
                        url = mUrl+'&page='+that.page+'&time='+that.time3;
                    }else{
                        url = mUrl + '&page='+that.page3;
                    }
                }
               

                //   数据列表
                that.$ajax({
                
                    method:'get',
                    url: url,
                    data: {},
                   
                }).then(res => {
                        
                    var total = res.data.data;
                    var list =res.data.data.list;

                    
                    that.total3 = total;
                    var len = list.length;
                    
                        
                    that.columns3 = [
                        {title:'孝心值来源',key:'type',align:'center'},
                        {title:'孝心值变化',key:'integral',align:'center'},
                        {title:'时间',key:'createTime',align:'center'},
                        {title:'备注',key:'content',align:'center'}
                        
                       
                        
                    ];

                   
                     for(var i=0;i<len;i++){
                       
                        //   孝心值来源
                        if(list[i].type == 0){
                            list[i].type = '注册';
                        }else if(list[i].type == 1){
                            list[i].type = '签到';
                        }else if(list[i].type == 2){
                            list[i].type = '邀请';
                        }else if(list[i].type == 3){
                            list[i].type = '红包';
                        }else if(list[i].type == 4){
                            list[i].type = '纪念堂相关 ';
                        }else if(list[i].type == 5){
                            list[i].type = '赠送孝心值';
                        }else{
                            list[i].type = '管理员';
                        }
                        //   孝心值变化
                        if(list[i].state == 1){
                            list[i].integral = '+'+list[i].integral;
                        }else if(list[i].state == 2){
                            list[i].integral = '-'+list[i].integral;
                        }
                       
                    }

                    that.data3 = list;

                    that.toatalPage3 = total.total;
                    that.pageSize3 = total.pageSize;
                    
                
                }).catch(err=>{
                    console.log(err)
                })

              
           },
         
           changepage3(index){
               var that = this;
              
               that.load3(2);
           },

            // search选择
           
            //    选择日期
           timeFun3(data){
               var that = this;
               
               that.page3 = 1;
               that.type3 = '';
              
            //    防止从其他搜索跳回来是时间第一次不刷新
               setTimeout(function(){
                    that.time3 = data;
               },100)
               
               that.load3(1)
               
           },

           typeFun3(val){
               var that = this;
                
              
                that.load3(1);
                that.time3 = '';
                
           },

        
           //导出数据
           //    导出
            exportData3(){
                var that = this;
                that.$refs.table3.exportCsv({
                    filename: '孝心值查询',
                    original: false
                });
               
            },
            // list4
            load4(btn){

                var that = this;
                 // vuex
                that.token = that.$store.state.token;
                 
                var url;
                var mUrl = 'admin/service/admin/user/search/commission/log?guid='+that.checkGuid2;
                //  0是关闭和初始,1是搜索框，2是分页
                if(btn == 0){
                    url = mUrl+'&page=1';  //初始化
                }else if(btn == 1){
                    if(that.type4){
                        url = mUrl+'&page=1&type='+that.type4;  //提交type
                    }else if(that.time4){
                        url = mUrl+'&page=1&time='+that.time4;   //提交time
                    }else{
                        url = mUrl + '&page=1';
                    }
                }else if(btn == 2){
                    if(that.type4){
                        url = mUrl+'&page='+that.page+'&type='+that.type4;
                    }else if(that.time4){
                        url = mUrl+'&page='+that.page+'&time='+that.time4;
                    }else{
                        url = mUrl + '&page='+that.page4;
                    }
                }
               

                //   数据列表
                that.$ajax({
                
                    method:'get',
                    url: url,
                    data: {},
                    
                }).then(res => {
                        
                    var total = res.data.data;
                    var list =res.data.data.list;

                    
                    that.total4 = total;
                    var len = list.length;
                    
                        
                    that.columns4 = [
                        {title:'订单编号',key:'order_guid',align:'center'},
                        {title:'提交时间',key:'create_time',align:'center',minWidth: 125},
                        {title:'用户账号',key:'mobile',align:'center'},
                        {title:'消费金额',key:'money',align:'center',minWidth:150},
                        {title:'佣金提成',key:'commission',align:'center'},
                        {title:'订单来源',key:'type',align:'center'},
                        {title:'提成比值',key:'royalty_rate',align:'center'}
                       
                                     
                    ];

                   
                    for(var i=0;i<len;i++){
                        //  消费金额
                        list[i].money = '￥'+ (list[i].money/100).toFixed(2);
                        //佣金提成
                        list[i].commission = '￥'+ (list[i].commission/100).toFixed(2);
                        //   订单来源
                        if(list[i].type == 1){
                            list[i].type = '孝心值充值';
                        }else if(list[i].type == 2){
                            list[i].type = '会员充值';
                        }else{
                            list[i].type = '购买商品';
                        }
                        //  提成比值 
                         list[i].royalty_rate = (list[i].royalty_rate*100) +'%';
                    }

                    that.data4 = list;

                    that.toatalPage4 = total.total;
                    that.pageSize4 = total.pageSize;
                    
                
                }).catch(err=>{
                    console.log(err)
                })

              
           },
         
           changepage4(index){
               var that = this;
              
               that.load4(2);
           },

            // search选择
           
            //    选择日期
           timeFun4(data){
               var that = this;
               
               that.page4 = 1;
               that.type4 = '';
              
            //    防止从其他搜索跳回来是时间第一次不刷新
               setTimeout(function(){
                    that.time4 = data;
               },100)
               
               that.load4(1)
             
           },

           typeFun4(val){
               var that = this;
                
              
                that.load4(1);
                that.time4 = '';
                
           },

        
           //导出数据
           //    导出
            exportData4(){
                var that = this;
                that.$refs.table4.exportCsv({
                    filename: '佣金列表',
                    original: false
                });
               
            },

            back(){   //返回list
                
                this.$store.commit('change_checkGuid2',null);
            }
            
            
        },
        mounted: function(){
           var that = this;
           
           that.load();

           that.load3(0);

           that.load4(0);
           
        }
    }
</script>
<style scoped>
    .table_content1 *{
        text-align: center;
    }
    .ivu-layout-footer{
        text-align: center;
    }
    /* iview table */
    .table table{
      width: 100% !important;
    }



    /* 顶部手写table */
    .table_content1{
        margin-top: 20px;
        background: #e4e4e4;
        font-size: 14px;
    }
    .table_content1 td{
        background: white;
    }
    .table_content1 .tableL{
        width: 250px;
        height: 250px;
         /* background: white; */
    }
    /* 手写table左侧 */
    .table_content1 p{
        padding: 5px 0;
    }
   
   .table_content1  .p1 img{
       width: 80px;
       height: 80px;
       border-radius: 50%;
       margin-top:15px;
   }
    .table_content1 .p3 span{
        padding: 4px 15px;
        background: #f04844;
        color:white;
        border-radius: 15px;
    }
    .table_content1 .p4{
        color: #1abc9c;
    }
    .table_content1 .title{
        width: 12.1111%;
        height: 33.333333333%;
        /* background: #f9fafc; */
        padding: 0 5px;
    }
    .table_content1 .t_con{
        width: 21.2222%;
    }
    


    /* 底部列表 */
   .my_table{
       width: 100%;
      
      
   }

   .title2{
       width: 100%;
       height: 68px;
       line-height: 68px;
       text-align: left;
       font-size: 17px;
   }
  .ivu-layout-footer{
      margin-bottom: 0!important;
  }
  .my_title_table{
      padding: 0 !important;
  }
  .my_title{
      margin-top: 0 !important;
  }

  
</style>



